export const PropertySearchSkeleton = () => (
  <div className="w-64 h-8 bg-gray-200 rounded-md animate-pulse"></div>
);
